import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import styled from "styled-components";

export const Accordion = styled((props) => (
  <MuiAccordion disableGutters {...props} />
))(({ theme }) => ({
  width: "100%",
  boxShadow: "none",
  border: "0px",
  padding: "0px",
  margin: "0px",
  "&:not(:last-child)": {},
  "&::before": {
    display: "none",
  },
}));

export const AccordionSummary = styled((props) => (
  <MuiAccordionSummary {...props} />
))(({ theme }) => ({
  padding: "0px",
  margin: "0px",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
    padding: "0px",
    margin: "0px",
    background: "none",
  },
  "& .MuiAccordionSummary-content": {
    fontFamily: "Marsden Wide",
    padding: "0px",
    margin: "0px",
  },
  "& .MuiAccordionSummary-root": {
    padding: "0px",
    margin: "0px",
  },
  "& .css-1nnke-MuiButtonBase-root-MuiAccordionSummary-root": {
    padding: "0px",
    margin: "0px",
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  background: "none",
  borderRadius: "0px",
  margin: "0px",
  padding: "0px",
}));
